'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _genericRowItem = require('../generic-row-item');

var _genericRowItem2 = _interopRequireDefault(_genericRowItem);

var _input = require('./input.scss');

var _input2 = _interopRequireDefault(_input);

var _keyCodes = require('../../../constants/key-codes');

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    setSearchQuery: _propTypes2.default.func.isRequired,
    showResults: _propTypes2.default.bool.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    filterDisplayed: _propTypes2.default.bool.isRequired,
    searchQuery: _propTypes2.default.string,
    placeholder: _propTypes2.default.string.isRequired,
    autocompleteHint: _propTypes2.default.string,
    focusOnLoad: _propTypes2.default.bool,
    setShowResults: _propTypes2.default.func.isRequired
};

var defaultProps = {
    searchQuery: '',
    autocompleteHint: '',
    focusOnLoad: false
};

var SearchInput = function (_React$PureComponent) {
    _inherits(SearchInput, _React$PureComponent);

    function SearchInput(props) {
        _classCallCheck(this, SearchInput);

        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);

        _this.state = { focused: false };
        return _this;
    }

    SearchInput.prototype.componentDidMount = function componentDidMount() {
        if (this.props.focusOnLoad) {
            this.focus();
        }
    };

    SearchInput.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.inputField.value !== this.props.searchQuery) {
            this.inputField.value = this.props.searchQuery;
        }
    };

    SearchInput.prototype.onChange = function onChange(e) {
        this.props.setSearchQuery(e.currentTarget.value);
    };

    SearchInput.prototype.onFocus = function onFocus() {
        this.setState({ focused: true });
        this.props.setShowResults(true);
    };

    SearchInput.prototype.onBlur = function onBlur() {
        this.setState({ focused: false });
    };

    SearchInput.prototype.onKeyUp = function onKeyUp(e) {
        var _props = this.props,
            autocompleteHint = _props.autocompleteHint,
            searchQuery = _props.searchQuery;


        if (e.keyCode === _keyCodes2.default.ENTER) {
            this.props.onSearch(searchQuery);
            this.blur();
            return;
        }

        if (e.keyCode === _keyCodes2.default.ARROW_RIGHT && autocompleteHint) {
            this.props.setSearchQuery(autocompleteHint);
        } else if (e.keyCode === _keyCodes2.default.TAB && autocompleteHint) {
            this.props.setSearchQuery(autocompleteHint);
        }

        if (this.state.focused) {
            this.props.setShowResults(true);
        }
    };

    SearchInput.prototype.getHintPlaceholder = function getHintPlaceholder() {
        var _props2 = this.props,
            searchQuery = _props2.searchQuery,
            autocompleteHint = _props2.autocompleteHint;


        if (this.state.focused && searchQuery && autocompleteHint) {
            return '' + searchQuery + autocompleteHint.substr(searchQuery.length);
        }

        return '';
    };

    SearchInput.prototype.focus = function focus() {
        this.inputField.focus();
    };

    SearchInput.prototype.blur = function blur() {
        this.inputField.blur();
    };

    SearchInput.prototype.render = function render() {
        var _classnames,
            _classnames2,
            _this2 = this;

        var _props3 = this.props,
            searchQuery = _props3.searchQuery,
            filterDisplayed = _props3.filterDisplayed,
            placeholder = _props3.placeholder;


        var searchInputClasses = (0, _classnames4.default)(_input2.default.searchInput, (_classnames = {}, _classnames[_input2.default.noFilter] = !filterDisplayed, _classnames));

        var searchHintClasses = (0, _classnames4.default)(_input2.default.searchInput, _input2.default.searchInputHint, (_classnames2 = {}, _classnames2[_input2.default.noFilter] = !filterDisplayed, _classnames2));

        return _react2.default.createElement(
            _genericRowItem2.default,
            { className: _input2.default.searchInputRow },
            _react2.default.createElement('input', {
                type: 'text',
                readOnly: true,
                autoComplete: 'off',
                spellCheck: 'false',
                className: searchHintClasses,
                placeholder: this.getHintPlaceholder()
            }),
            _react2.default.createElement('input', {
                ref: function ref(n) {
                    _this2.inputField = n;
                },
                className: searchInputClasses,
                placeholder: placeholder,
                type: 'search',
                onChange: this.onChange,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyUp: function onKeyUp(e) {
                    _this2.onKeyUp(e);
                },
                onKeyDown: function onKeyDown(e) {
                    if (e.keyCode === _keyCodes2.default.TAB) {
                        // Allow tab to be detected by onKeyUp
                        e.preventDefault();
                    }
                },
                defaultValue: searchQuery,
                'data-auto-input': 'search:input'
            })
        );
    };

    return SearchInput;
}(_react2.default.PureComponent);

exports.default = SearchInput;


SearchInput.propTypes = propTypes;
SearchInput.defaultProps = defaultProps;